// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5f86199a]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.store-layout-method__wrapper[data-v-5f86199a]{background:hsla(0,0%,100%,.05);margin-top:.5rem;padding:.5rem}.store-layout-method__wrapper[data-v-5f86199a] .menu-item .menu-select .label{color:hsla(0,0%,100%,.9)}.store-layout-method__wrapper .num-select[data-v-5f86199a]{margin-top:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
